import { render, staticRenderFns } from "./personQuery.vue?vue&type=template&id=98aa3d2c"
import script from "./personQuery.vue?vue&type=script&lang=js"
export * from "./personQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports